export const WydenApiMap = [
  {
    envs: ['local', 'ci'],
    api: 'http://localhost:5001',
    apm: 'https://0a45548b388140afad378bed5b3c4c21.apm.eastus.azure.elastic-cloud.com:443',
    brand: 'wyden',
    tempoDedupping: 1800000,
  },
  {
    envs: ['dev'],
    api: 'https://apis.candidato.wyden.sava.dev.yduqs.com.br/rest',
    apm: 'https://0a45548b388140afad378bed5b3c4c21.apm.eastus.azure.elastic-cloud.com:443',
    brand: 'wyden',
    tempoDedupping: 1800000,
  },
  {
    envs: ['qld'],
    api: 'https://apis.candidato.wyden.sava.qld.yduqs.com.br/rest',
    apm: 'https://0a45548b388140afad378bed5b3c4c21.apm.eastus.azure.elastic-cloud.com:443',
    brand: 'wyden',
    tempoDedupping: 1800000,
  },
  {
    envs: ['prd'],
    api: 'https://apis.candidatos.sava.wyden.com.br/rest',
    apm: 'https://0a45548b388140afad378bed5b3c4c21.apm.eastus.azure.elastic-cloud.com:443',
    brand: 'wyden',
    tempoDedupping: 1800000,
  },
];
